// componentes/HeaderMensaje.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Imagy from '../assets/imagyLogo.png';

const HeaderMensaje = () => {
  const location = useLocation();

  if (location.pathname !== '/' && location.pathname !== '/bot') {
    return null; // No renderiza nada si no está en estas rutas
  }
/*
  const mensaje = location.pathname === '/'
    ? 'Bienvenidos a Imagina Soluciones IT – Tecnología accesible para clínicas y negocios modernos.'
    : 'Imagy – Bajá el ausentismo y mejorá la atención.';

  return (
    <div style={{ 
      backgroundColor: '#FFA500', 
      color: 'black', 
      padding: '10px 16px', 
      textAlign: 'center', 
      fontWeight: '500', 
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
    }}>
      <img 
        src={Imagy} 
        alt="Imagy Bot" 
        style={{ height: '22px', width: '22px' }} 
      />
      <span>{mensaje}</span>
    </div>
  );
  */
};

export default HeaderMensaje;
